import {
	alias,
	deserialize,
	identifier,
	object,
	serializable,
} from "serializr";
import { IJsonObject } from "../api";
import { Lead } from "../leads";
import { User } from "../users";

interface IProps {
	id?: number | null;
	userId?: number | null;
	user?: User | null;
	lead?: Lead | null;
}

export class ProjectMember {
	public static fromJson(json: IJsonObject): ProjectMember {
		return deserialize(ProjectMember, json);
	}

	public static fromJsonArray(json: IJsonObject[]): ProjectMember[] {
		return json.map((task: IJsonObject) => this.fromJson(task));
	}

	@serializable(identifier())
	public id: number | null;

	@serializable(alias("user_id"))
	public userId: number | null;

	@serializable(object(User))
	public user: User | null;

	@serializable(object(Lead))
	public lead: Lead | null;

	constructor({
		id = null,
		userId = null,
		user = null,
		lead = null,
	}: IProps = {}) {
		this.id = id;
		this.userId = userId;
		this.user = user;
		this.lead = lead;
	}
}
